import { useCallback, useEffect, useState } from "react";
import { Toolbar, AppBar, Box, Typography, Button, Tooltip, IconButton } from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import MenuIcon from "@mui/icons-material/Menu";
import { drawerWidth } from "./NavigationDrawer";
import { ReactComponent as Logo } from "./../../../logo.svg";
import TimerIcon from "@mui/icons-material/Timer";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { daysLeftSelector } from "../../../store/proposalSlice";
import { institutionSelector } from "../../../store/researchauthoritiesSlice";
import CustomBox from "../../public/Components/CustomBox";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";

export const toolbarHeight = 80;

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    alignItems: "center",
    width: "100%",
    justifyContent: "flex-end",
    "& > *": {
      marginLeft: theme.spacing(6),
    },
    marginRight: theme.spacing(2),
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  toolbar: {
    paddingRight: theme.spacing(1),
    minHeight: toolbarHeight,
    backgroundColor: process.env.REACT_APP_TOOLBAR_COLOR || "#FFF",
    color: "black",
  },
  title: {
    position: "absolute",
    left: 0,
    marginLeft: drawerWidth,
  },
  tabs: {
    marginTop: 25,
    marginRight: 100,
  },
  pairsValue: {
    fontWeight: 600,
    marginLeft: 7,
  },
  buttonsWrapper: {
    "& > *": {
      marginLeft: theme.spacing(1),
    },
  },
  button: {
    "&:hover": {
      backgroundColor: theme.palette.gif.blue.hover,
    },
    color: theme.palette.gif.blue.color,
    backgroundColor: theme.palette.gif.blue.background,
  },
  logo: {
    position: "absolute",
    left: 85,
  },
}));

export default function ApplicationBar(props) {
  const classes = useStyles();
  const history = useHistory();
  const institution = useSelector(institutionSelector);
  const daysLeft = useSelector(daysLeftSelector);

  const [infos, setInfos] = useState([]);
  const { setOpen } = props;

  const onOpen = useCallback(
    (event) => {
      setOpen();
    },
    [setOpen]
  );

  useEffect(() => {
    const infos = [
      { key: " ", value: institution?.name },
      {
        key: "Days Left",
        value: daysLeft.totalDaysLeft,
        icon: TimerIcon,
        tooltip: `Due date: ${daysLeft.endFormatted}`,
      },
    ];
    setInfos(infos);
  }, [institution?.name, daysLeft]);

  return (
    <AppBar position="absolute" className={classes.appBar}>
      <Toolbar className={classes.toolbar}>
        <IconButton
          color="inherit"
          aria-label="open drawer"
          edge="start"
          className={classes.menuButton}
          onClick={onOpen}
          size="large">
          <MenuIcon />
        </IconButton>
        <Logo className={classes.logo} onClick={() => history.push("/")} />
        <CustomBox className={classes.title} fw={600} fs={18}>
          Research Authorities Portal
        </CustomBox>
        <Box className={classes.root}>
          {infos.map((info) => (
            <Tooltip
              title={info.tooltip || ""}
              placement="bottom"
              key={info.key}
            >
              <Box>
                <Typography
                  className={classes.pairsKey}
                  component="span"
                  variant="subtitle2"
                  color="inherit"
                  noWrap
                >
                  {info.key}
                </Typography>
                <Typography
                  className={classes.pairsValue}
                  component="span"
                  color="inherit"
                  noWrap
                >
                  {info.value}
                </Typography>
              </Box>
            </Tooltip>
          ))}
          <Box className={classes.buttonsWrapper}>
            <Button
              variant="contained"
              color="secondary"
              className={classes.button}
              disableElevation
              startIcon={<HelpOutlineIcon />}
            >
              Instructions
            </Button>
          </Box>
        </Box>
      </Toolbar>
    </AppBar>
  );
}
